import React from 'react';
import CMPImage from 'components/global/image';

const ItemIcon: React.FunctionComponent = () => {
  const src = '/images/item.png';
  return <CMPImage asset={{ src, alt: 'Character' }} width={16} height={18} />;
};

export default ItemIcon;
